/**
 * Convert markdown to HTML for display in formly fields
 * Handles common markdown patterns including malformed ones from Tripetto
 */
export function convertMarkdownToHtml(text: string | undefined): string | undefined {
	if (!text) {
		return text;
	}

	let html = text;

	// Strip Tripetto required field indicators (trailing * * at end of text)
	// Tripetto appends "* *" to field names/descriptions as a required marker.
	// Formly handles required indicators separately via props.required, so strip these.
	html = html.replace(/\s*\*\s+\*\s*$/, '');

	// Convert headers (must be done before other conversions)
	html = html.replace(/^### (.*$)/gm, '<h3>$1</h3>');
	html = html.replace(/^## (.*$)/gm, '<h2>$1</h2>');
	html = html.replace(/^# (.*$)/gm, '<h1>$1</h1>');

	// Convert bold: **text** or __text__
	html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
	html = html.replace(/__(.+?)__/g, '<strong>$1</strong>');

	// Convert italic: *text* or _text_ (but not in URLs or already converted tags)
	html = html.replace(/(?<![\w/:])\*([^\s*][^*]*?)\*(?![\w>])/g, '<em>$1</em>');
	html = html.replace(/(?<![\w/:<])_([^\s_][^_]*?)_(?![\w>])/g, '<em>$1</em>');

	// Convert links: [text](url)
	html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank">$1</a>');

	// Convert line breaks (double newline to paragraph, single newline to br)
	html = html.replace(/\n\n/g, '</p><p>');
	html = html.replace(/\n/g, '<br>');

	// Wrap in paragraph if it contains br or was split into paragraphs
	if (html.includes('<br>') || html.includes('</p>')) {
		html = '<p>' + html + '</p>';
		// Clean up empty paragraphs
		html = html.replace(/<p><\/p>/g, '');
	}

	// Convert unordered lists: - item or * item
	html = html.replace(/^[*-] (.+)$/gm, '<li>$1</li>');
	html = html.replace(/(<li>.*<\/li>)/s, '<ul>$1</ul>');

	// Convert ordered lists: 1. item
	html = html.replace(/^\d+\. (.+)$/gm, '<li>$1</li>');

	return html;
}
